import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ItemsPerPageBuilder } from '../../models/builder/items-per-page-builder';

@Injectable()
export class SettingApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
  ) {
    this.apiUrl = `${ environment.companyAdmin.apiUrl }settings/`;
  }

  getPollGroupPerPage() {
    return this.httpClient.get(`${ this.apiUrl }poll-groups-per-page`).pipe(map(ItemsPerPageBuilder.fromJson));
  }

  getPollPerPage() {
    return this.httpClient.get(`${ this.apiUrl }polls-per-page`).pipe(map(ItemsPerPageBuilder.fromJson));
  }

}
